import { FC } from 'react';

import { Box, keyframes, styled } from '@mui/material';

import { Icon } from '@sdb/planning-ui';
import type { IconType } from '@sdb/planning-ui/ui-3/packages/icons/__generated__';

const pulse = keyframes`
 from {
    transform: translate(-50%, -50%) scale3d(1, 1, 1);
    opacity: 0.5;
  }

  50% {
    transform: translate(-50%, -50%) scale3d(1.05, 1.05, 1.05);
    opacity: 0.9;

  }

  to {
    transform: translate(-50%, -50%) scale3d(1, 1, 1);
    opacity: 0.5;
  }
`;

const IconWrapper = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  font-size: 64px;
  animation: ${pulse} 1.5s ease-in-out infinite;
  opacity: 0.5;

  svg {
    color: rgba(2, 56, 80, 0.11);
  }
`;

interface SkeletonWithIconProps {
  icon?: IconType;
  width?: number | string;
  height?: number | string;
}

const SkeletonWithIcon: FC<SkeletonWithIconProps> = ({
  icon = 'chart-bar',
  width = '100%',
  height = '100%'
}) => (
  <Box position="relative" width={width} height={height}>
    <IconWrapper>
      <Icon type={icon} fontSize="inherit" />
    </IconWrapper>
  </Box>
);

export default SkeletonWithIcon;
